import { PermissionSet, useBusinessContext, usePermission, usePermissionsLoaded } from '@context'
import {
  dashboardQueryKey,
  fetchDashboardBootstrap,
  IDashboardBootstrap,
  IDashboardOverview,
  dashboardQueryOptions
} from '@query'
import { useQuery } from '@tanstack/react-query'

export const useDashboardBootstrap = () => {
  const { slug } = useBusinessContext()
  const permissionsLoaded = usePermissionsLoaded()
  const canViewBookkeeping = usePermission(PermissionSet.BOOKKEEPING_VIEW)
  const queryKey = dashboardQueryKey(slug, 'bootstrap')

  return useQuery<IDashboardBootstrap>({
    queryKey,
    queryFn: () => fetchDashboardBootstrap({ slug }),
    ...{
      enabled: Boolean(slug) && permissionsLoaded && canViewBookkeeping,
      ...dashboardQueryOptions(slug)
    }
  })
}

export const useDashboardOverview = (): {
  data: IDashboardOverview | undefined
  isLoading: boolean
  isPending: boolean
} => {
  const { data, isLoading, isPending } = useDashboardBootstrap()
  return {
    data: data?.overview,
    isLoading,
    isPending
  }
}
